/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_VideoInputs */

const zh_sidebar_video = /** @type {(inputs: Sidebar_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频`)
};

const en_sidebar_video = /** @type {(inputs: Sidebar_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

const es_sidebar_video = /** @type {(inputs: Sidebar_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

/**
* | output |
* | --- |
* | "Video" |
*
* @param {Sidebar_VideoInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const sidebar_video = /** @type {((inputs?: Sidebar_VideoInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_VideoInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_sidebar_video(inputs)
	if (locale === "en") return en_sidebar_video(inputs)
	return es_sidebar_video(inputs)
});